import { Category } from '../category/category.model';

export enum EMBARCADERE {
    SAVEL = 'MAYRES-SAVEL',
    TREFFORT = 'TREFFORT',
}

export class Schedule {
    _id?: string;
    time: string;
    duration: string;
    embarcadere: string;
    closedDates?: Date[];
}

export class Ticket {
    _id?: string;
    title: string;
    description?: string;
    amount: number;
    discountAmount?: number;
    vatRate?: number;
    hidden?: boolean;
}

export class Product {
    _id: string;
    type: string;
    title: string;
    description: string;
    title_en: string;
    description_en: string;
    // image: Types.ObjectId | StorageEntity;
    // imageLarge: Types.ObjectId | StorageEntity;
    carte: {
        _id: string,
        key: string,
        size: number,
        mimetype: string,
        storageType: string,
        url: string,
    };
    category: Category;
    parentCategory: string;
    annualRecurrence: boolean;
    recurrenceStart: Date;
    recurrenceEnd: Date;
    schedules: Schedule[];
    tickets: Ticket[];
    quantity: number;
    tresholdAlert: number;
    tresholdDiscount?: number;
    tresholdFreeSeat?: number;
    createdAt: Date;
    updatedAt: Date;
    disabled: boolean;
    hidden: boolean;
    package: boolean;
    giftcard: boolean;
    comment: boolean;
    workingDays: Date[];
    nonworkingDays: Date[];

    constructor(product?)
    {
        // Object.assign(this, product || {});
        product = product || {};
        this._id = product._id || null;
        this.type = product.type || null;
        this.category = product.category || {};
        this.parentCategory = product.parentCategory || {};
        this.title = product.title || null;
        this.description = product.description || null;
        this.title_en = product.title_en || null;
        this.description_en = product.description_en || null;
        this.annualRecurrence = product.annualRecurrence || false;
        this.recurrenceStart = product.recurrenceStart || null;
        this.recurrenceEnd = product.recurrenceEnd || null;
        this.schedules = product.schedules || [];
        this.tickets = product.tickets || [];
        this.quantity = product.quantity || 0;
        this.tresholdAlert = product.tresholdAlert || 0;
        this.tresholdDiscount = product.tresholdDiscount || 0;
        this.tresholdFreeSeat = product.tresholdFreeSeat;
        this.createdAt = product.createdAt || null;
        this.updatedAt = product.updatedAt || null;
        this.disabled = product.disabled || false;
        this.hidden = product.hidden || false;
        this.package = product.package || false;
        this.giftcard = product.giftcard || false;
        this.comment = product.comment || false;
        this.workingDays = product.workingDays || [];
        this.nonworkingDays = product.nonworkingDays || [];
        this.carte = product.carte || null;
    }

    addSchedule(schedule: Schedule)
    {
        this.schedules.push(schedule);
    }

    removeSchedule(schedule)
    {
        const index = this.schedules.indexOf(schedule);
        if ( index >= 0 )
        {
            this.schedules.splice(index, 1);
        }
    }

    addTicket(newTicket)
    {
        this.tickets.push(newTicket);
    }

    removeTicket(ticket)
    {
        const index = this.tickets.indexOf(ticket);
        if ( index >= 0 )
        {
            this.tickets.splice(index, 1);
        }
    }

    addWorkingDay(day: Date)
    {
        this.workingDays.push(day);
    }

    removeWorkingDay(date)
    {
        const index = this.workingDays.indexOf(date);
        if ( index >= 0 )
        {
            this.workingDays.splice(index, 1);
        }
    }

    addNonWorkingDay(day: Date)
    {
        this.nonworkingDays.push(day);
    }

    removeNonWorkingDay(date)
    {
        const index = this.nonworkingDays.indexOf(date);
        if ( index >= 0 )
        {
            this.nonworkingDays.splice(index, 1);
        }
    }
}



// WEBPACK FOOTER //
// /usr/app/src/app/main/content/app/product/product.model.ts